/* =========================================================
   CTA
========================================================= */

import React from "react";

const CTASection = ({ data }) => (
    <section className="cta" id="contact">

        <div className="container">

            <div className="eyebrow">
                {data.eyebrow}
            </div>

            <h2>{data.title}</h2>

            <p>{data.description}</p>

            <div
                className="buttons"
                style={{ justifyContent: "center" }}
            >

                {(data.buttons || []).map((item, i) => (
                    <a
                        key={i}
                        href={item.url || "#"}
                        className={
                            i === 0
                                ? "btn btn-primary"
                                : "btn btn-secondary"
                        }
                    >
                        {item.text}
                    </a>
                ))}

            </div>

        </div>

    </section>
);

export default CTASection;